var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-container"},[_c('header',{staticClass:"c-header"},[_c('img',{attrs:{"height":"40px","src":"/img/logo_treed_v1.svg","alt":"logo"},on:{"click":_vm.mainPage}})]),_c('div',[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }